export default "__VITE_PUBLIC_ASSET__8d536cf4__"